import React, {useEffect} from 'react';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as lineActions from '../../../../_redux/orderlines/orderlinesActions';
import BootstrapTable from "react-bootstrap-table-next";
import * as uiHelpers from "../../OrdersListUIHelpers";
import {
    getHandlerTableChange,
    getSelectRow,
    NoRecordsFoundMessage,
    PleaseWaitMessage
} from "../../../../../../../_metronic/_helpers";

export function OrderLinesTable(){
    
    const dispatch = useDispatch();

    
    const {selectedOrder, orderLines} = useSelector(
        (state) => ({
            selectedOrder: state.orders.selectedOrder,
            orderLines: state.orderlines.entities
        }),
        shallowEqual
    );
    
    
    useEffect(() => {
        if(selectedOrder) {
            dispatch(lineActions.getOrderlines(selectedOrder.id));
        }   
    }, [dispatch, selectedOrder]);
    
    const columns = [
        {
            dataField: "productName",
            text: "نام محصول",
        },
        {
            dataField: "qty",
            text: "تعداد ثبت شده"
        },
        {
            dataField: "qtyFinal",
            text: "تعداد درخواستی با ضریب"
        }
    ]
    
    
    return(
            <BootstrapTable
                wrapperClasses={"table-responsive"}
                classes={"table table-head-custom table-vertical-center overflow-hidden"}
                bootstrap4
                bordered={false}
                remote
                keyField={"id"}
                data={orderLines === null ? [] : orderLines}
                columns={columns}>
                <PleaseWaitMessage entities={orderLines}/>
                <NoRecordsFoundMessage entities={orderLines}/>
            </BootstrapTable>
    )
    
}